module.exports = __webpack_public_path__ + "media/country_flags/kw-4ed7e59c.png";